var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCirclePlusSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid-user-circle-plus (2) 1",
    clipPath: "url(#clip0_492_7547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6001 18.4688C17.6001 22.3506 20.8251 25.5 24.8001 25.5C28.7751 25.5 32.0001 22.3506 32.0001 18.4688C32.0001 14.5869 28.7751 11.4375 24.8001 11.4375C20.8251 11.4375 17.6001 14.5869 17.6001 18.4688ZM20.8001 18.4688C20.8001 18.0391 21.1601 17.6875 21.6001 17.6875H24.0001V15.3438C24.0001 14.9141 24.3601 14.5625 24.8001 14.5625C25.2401 14.5625 25.6001 14.9141 25.6001 15.3438V17.6875H28.0001C28.4401 17.6875 28.8001 18.0391 28.8001 18.4688C28.8001 18.8984 28.4401 19.25 28.0001 19.25H25.6001V21.5938C25.6001 22.0234 25.2401 22.375 24.8001 22.375C24.3601 22.375 24.0001 22.0234 24.0001 21.5938V19.25H21.6001C21.1601 19.25 20.8001 18.8984 20.8001 18.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0498C0 24.8506 0.665 25.5 1.485 25.5H19.74C17.48 23.9424 16 21.374 16 18.4688C16 17.5459 16.15 16.6572 16.425 15.8271C15.505 15.5146 14.515 15.3438 13.485 15.3438H8.915C3.99 15.3438 0 19.2402 0 24.0498ZM5.655 3.625C4.51 5.55859 4.51 7.94141 5.655 9.875C6.8 11.8086 8.91 13 11.2 13C13.49 13 15.6 11.8086 16.745 9.875C17.89 7.94141 17.89 5.55859 16.745 3.625C15.6 1.69141 13.485 0.5 11.2 0.5C8.915 0.5 6.8 1.69141 5.655 3.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0498C0 24.8506 0.665 25.5 1.485 25.5H19.74C17.48 23.9424 16 21.374 16 18.4688C16 17.5459 16.15 16.6572 16.425 15.8271C15.505 15.5146 14.515 15.3438 13.485 15.3438H8.915C3.99 15.3438 0 19.2402 0 24.0498ZM5.655 3.625C4.51 5.55859 4.51 7.94141 5.655 9.875C6.8 11.8086 8.91 13 11.2 13C13.49 13 15.6 11.8086 16.745 9.875C17.89 7.94141 17.89 5.55859 16.745 3.625C15.6 1.69141 13.485 0.5 11.2 0.5C8.915 0.5 6.8 1.69141 5.655 3.625Z",
    fill: "url(#paint0_linear_492_7547)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_7547",
    x1: 0.162343,
    y1: 25.5,
    x2: 25.0444,
    y2: 17.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_7547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCirclePlusSolid);
export default __webpack_public_path__ + "static/media/user-circle-plus-solid.21aa5704a17c3bfd0efdc3cf356cefa4.svg";
export { ForwardRef as ReactComponent };